
import * as constants from '../Constatnts'
import axios from 'axios';


export function getAttendance(
  storeID, // Made compulsory by removing default null value
  from = 0,
  size = 25,
  fromDate = null,
  toDate = null,
  searchParam = null,
  status
) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      let apiUrl = "/staff/attendance";

      const params = {
        from: Number(from),
        size: Number(size),
        StoreID: storeID,
        fromDate: fromDate,
        toDate: toDate,
        searchParam: searchParam,
        status: status,
      };

      let queryParams = [];

      Object.keys(params).forEach((key) => {
        if (
          Object.prototype.hasOwnProperty.call(params, key) &&
          params[key] !== undefined &&
          params[key] !== null &&
          params[key] !== ""
        ) {
          queryParams.push(
            key + "=" + encodeURIComponent(params[key])
          );
        }
      });

      if (queryParams.length > 0) {
        apiUrl = apiUrl + "?" + queryParams.join("&");
      }

      const response = await axios.get(
        constants.API_URL + apiUrl,
        {
          headers: {
            Authorization: "Bearer " + token
          }
        }
      );

      if (
        response &&
        Object.prototype.hasOwnProperty.call(response, "data")
      ) {
        return response.data;
      }

      return null;
    } catch (error) {
      console.error("Error fetching expense data:", error);

      if (
        error &&
        Object.prototype.hasOwnProperty.call(error, "response") &&
        error.response &&
        Object.prototype.hasOwnProperty.call(error.response, "data")
      ) {
        throw error.response.data;
      }

      throw error;
    }
  };
}



export function saveAttendance(attendance, key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      let response = {};

      if (key !== "") {
        // Update existing account
        response = await axios.put(
          `${constants.API_URL}/staff/attendance/${key}`,
          attendance,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        // Create new account
        response = await axios.post(
          `${constants.API_URL}/staff/addattendance`,
          attendance,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      if (response.data.code === "0") {
        if (key) {
          return key;
        } else {
          return response.data.attendanceId;
        }
      }

      return null;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}
